export default {
    namespaced: true,
    state: {
        minConsiderations: 3,
        maxDecisions: 4,
        scoreRating: {
            decisions: {
                2: {
                    tolerance: {
                        high: {
                            upper: 0.55,
                            lower: 0.55,
                        },
                        moderate: {
                            upper: 0.7,
                            lower: 0.7
                        },
                        low: {
                            upper: 0.8,
                            lower: 0.8
                        }
                    }
                },
                3: {
                    tolerance: {
                        high: {
                            upper: 0.45,
                            lower: 0.65
                        },
                        moderate: {
                            upper: 0.65,
                            lower: 0.75
                        },
                        low: {
                            upper: 0.75,
                            lower: 0.85
                        }
                    }
                },
                4: {
                    tolerance: {
                        high: {
                            upper: 0.45,
                            upper_intermediate: 0.54,
                            lower_intermediate: 0.59,
                            lower: 0.65
                        },
                        moderate: {
                            upper: 0.65,
                            upper_intermediate: 0.69,
                            lower_intermediate: 0.72,
                            lower: 0.75
                        },
                        low: {
                            upper: 0.75,
                            upper_intermediate: 0.79,
                            lower_intermediate: 0.82,
                            lower: 0.85
                        }
                    }
                }
            }
        }
    },


}
